import { get, put, throwIfError } from 'utils/api';

export const postWagesAndIncome = async (
  orgId,
  propertyId,
  affordableQualificationId,
  applicantId,
  data,
  options,
) => {
  const { memberId, ...newData } = data;

  const response = await put(
    `/portal/${orgId}/${propertyId}/affordable-qualifications/${affordableQualificationId}/applicants/${applicantId}/affordable-qualification-checklist`,
    { ...newData },
    options,
  );

  return throwIfError(response);
};

export const getWagesAndIncomeSummary = async (
  organizationId,
  propertyId,
  householdId,
  options,
) => {
  const url = `/portal/${organizationId}/${propertyId}/households/${householdId}`;
  const response = await get(url, options);

  if (response.error) {
    return response.error;
  }

  return response;
};

export const getWagesAndIncome = async (
  organizationId,
  propertyId,
  householdId,
  options,
) => {
  const url = `/portal/${organizationId}/${propertyId}/all-household-members/${householdId}`;
  const response = await get(url, options);

  if (response.error) {
    return response.error;
  }

  return response;
};
